var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cantact",staticStyle:{"margin-top":"-56px"}},[_c('contant'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }